import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

const DescriptionCell = ({ description, format = false }) => {
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const truncateDescription = (text, wordLimit) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text; 
    const plainText = tempDiv.textContent || tempDiv.innerText || "";
    const words = plainText.split(" ");
    if (words.length > wordLimit) {
      return `${words.slice(0, wordLimit).join(" ")}...`;
    }
    return plainText;
  };

  // Responsive word limits based on screen size
  const getWordLimit = () => {
    if (typeof window !== 'undefined') {
      const width = window.innerWidth;
      if (width < 576) return 8; // Extra small screens
      if (width < 768) return 10; // Small screens
      if (width < 992) return 12; // Medium screens
      return 15; // Large screens and above
    }
    return 15; // Default fallback
  };

  const [wordLimit, setWordLimit] = useState(getWordLimit());

  // Update word limit on window resize
  React.useEffect(() => {
    const handleResize = () => {
      setWordLimit(getWordLimit());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const shouldShowMore = description.split(" ").length > wordLimit;

  return (
    <td style={{ verticalAlign: "center" }}>
      <div 
        style={{ 
          marginBottom: "8px",
          textAlign: "left",
          wordBreak: "break-word",
          hyphens: "auto",
          lineHeight: "1.4"
        }}
      >
        <span style={{ fontSize: "14px" }}>
          {truncateDescription(description, wordLimit)}
        </span>
        {shouldShowMore && format !== true && (
          <>
            <span
              onClick={handleShowModal}
              style={{ 
                color: "blue", 
                cursor: "pointer", 
                marginLeft: "5px",
                fontSize: "12px",
                textDecoration: "underline",
                whiteSpace: "nowrap"
              }}
            >
              show more
            </span>
            <Modal
              show={showModal}
              onHide={handleCloseModal}
              centered
              backdrop="static"
              size="lg"
              className="description-modal"
            >
              <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: "1.1rem" }}>
                  Full Description
                </Modal.Title>
              </Modal.Header>
              <Modal.Body 
                style={{ 
                  maxHeight: "60vh", 
                  overflowY: "auto",
                  wordBreak: "break-word",
                  lineHeight: "1.5"
                }}
              >
                <p style={{ margin: 0, fontSize: "14px" }}>
                  {description}
                </p>
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-end">
                <Button 
                  variant="secondary" 
                  onClick={handleCloseModal}
                  size="sm"
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        )}
      </div>

      {/* Add responsive CSS styles */}
      <style jsx>{`
        @media (max-width: 575px) {
          .description-modal .modal-dialog {
            margin: 10px;
            max-width: calc(100vw - 20px);
          }
          .description-modal .modal-body {
            padding: 15px;
            font-size: 13px;
          }
          .description-modal .modal-header {
            padding: 10px 15px;
          }
          .description-modal .modal-footer {
            padding: 10px 15px;
          }
        }

        @media (min-width: 576px) and (max-width: 767px) {
          .description-modal .modal-dialog {
            max-width: 90vw;
          }
        }

        @media (min-width: 768px) and (max-width: 991px) {
          .description-modal .modal-dialog {
            max-width: 80vw;
          }
        }

        .description-modal .modal-content {
          border-radius: 8px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        .description-modal .modal-header {
          border-bottom: 1px solid #dee2e6;
          background-color: #f8f9fa;
        }

        .description-modal .modal-footer {
          border-top: 1px solid #dee2e6;
          background-color: #f8f9fa;
        }
      `}</style>
    </td>
  );
};

export default DescriptionCell;